import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import { sendGTMEvent } from '@next/third-parties/google'
import { mapUrlToEventLocation } from '../../helpers/mapUrlToEventLocation'

export type GtmCreateAccountCompletedType = {
  user_id: string
  user_market: Alpha2CountryCode
  user_language: string
  enroller_id: number
  sponsor_id: number
  referral_code?: string
  user_market_extended: Alpha2CountryCode
  membership_registration_date: string
  user_type: string
  is_user_logged_in: boolean
}

export const gtmCreateAccountCompleted = ({
  user_id,
  user_market,
  user_language,
  enroller_id,
  sponsor_id,
  referral_code,
  user_market_extended,
  membership_registration_date,
  user_type,
  is_user_logged_in,
}: GtmCreateAccountCompletedType) => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_create_account_completed',
    event_id: uuid,
    event_location: mapUrlToEventLocation(window.location.href),
    user_id,
    user_market,
    user_language,
    enroller_id,
    sponsor_id,
    referral_code,
    user_market_extended,
    membership_registration_date,
    user_type,
    is_user_logged_in,
    has_made_purchase: false,
  })
}
